import React from "react"

const Sponsors = () => (
  <>
    <section id="tg-organisators" className="tg-sectionspace tg-haslayout">
      <div className="container">
        <div className="row">
          <div
            className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8">
            <div className="tg-sectionhead">
              <div className="tg-sectionheading">
                <h2>Organizatorzy</h2>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <ul className="tg-brands">
              <li className="tg-brand">
                <figure><a href="http://www.rekord.com.pl" target="_blank" rel="noopener noreferrer"><img
                  src="images/sponsorzy/rekord.png" alt="Rekord"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://selleo.com/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/selleo.png" alt="Selleo"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.elliemae.com/" target="_blank" rel="noopener noreferrer"><img
                  src="images/sponsorzy/elliemae.png" alt="Ellie Mae"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.precisely.com/" target="_blank" rel="noopener noreferrer"><img
                  src="images/sponsorzy/precisely.png" alt="Precisely"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="http://www.fcnt.eu/kontakt.html" target="_blank" rel="noopener noreferrer"><img
                  src="images/sponsorzy/fcnt.png" alt="FCNT"/></a></figure>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section id="tg-partners" className="tg-haslayout">
      <div className="container tg-sectionspace">
        <div className="row">
          <div
            className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8">
            <div className="tg-sectionhead">
              <div className="tg-sectionheading">
                <h2>Partnerzy</h2>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <ul className="tg-brands">
              <li className="tg-brand">
                <figure><a href="https://www.davinci-studio.com/pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/davinci.png" alt="Davinci Studio"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://jantar.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/jantar.png" alt="Jantar"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://4experience.co/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/4exp.png" alt="4Experience"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://wizja.net/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/wizja_net.png" alt="Wizja.net"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.versum.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/versum.png" alt="Versum"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="http://www.next.biz.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/next.png" alt="Next!"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://inelo.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/inelo.png" alt="INELO"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="http://www.fablab24.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/fablab.png" alt="Fab Lab"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.pitneybowes.com/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/pitney.png" alt="Pitney Bowes"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://buddy.works/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/buddy.png" alt="Buddy"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.meetup.com/pl-PL/Bielsko-Biala-JUG/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/jug.png" alt="JUG"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.meetup.com/pl-PL/meet-js-Bielsko-Biala/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/meetjs.png" alt="Meet JS"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.meetup.com/pl-PL/Mikstura-IT/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/mikstura.png" alt="Mikstura IT"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.startuppodbeskidzie.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/sp.png" alt="Startup Podbeskidzie"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://innerweb.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/inner.png" alt="Inner Web"/></a></figure>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container tg-sectionspace">
        <div className="row">
          <div
            className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8">
            <div className="tg-sectionhead">
              <div className="tg-sectionheading">
                <h2>Partnerzy biznesowi</h2>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <ul className="tg-brands">
              <li className="tg-brand">
                <figure><a href="https://arrsa.pl/pl/kon.html" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/arsabb.png" alt="ARS BB"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.bcc.org.pl/loze-regionalne/loza-bielska/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/bcc.png" alt="BCC"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="http://www.cci.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/rihip.png" alt="Regionalna Izba Handlu i Przemysłu"/></a></figure>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container tg-sectionspace">
        <div className="row">
          <div
            className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8">
            <div className="tg-sectionhead">
              <div className="tg-sectionheading">
                <h2>Patronat Prezydenta Miasta Bielska-Białej </h2>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <ul className="tg-brands">
              <li className="tg-brand">
                <figure><a href="http://www.bielsko-biala.pl" target="_blank" rel="noopener noreferrer"><img
                  src="images/sponsorzy/bielsko-biala.png" alt="Urząd Miasta Bielsko-Biała"/></a></figure>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container tg-sectionspace">
        <div className="row">
          <div
            className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8">
            <div className="tg-sectionhead">
              <div className="tg-sectionheading">
                <h2>Partnerzy Naukowi</h2>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <ul className="tg-brands">
              <li className="tg-brand">
                <figure><a href="https://www.ath.bielsko.pl" target="_blank" rel="noopener noreferrer"><img
                  src="images/sponsorzy/ath.png" alt="Akademia Techniczno-Humanistyczna w Bielsku-Białej"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.wsi.edu.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/media/wsiz-bb.png" alt="Wyższa Szkoła Zarządzania i Informatyki"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://technikum.wsi.edu.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/media/pti.png" alt="Prywatne Technikum Informatyczne"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://wsb.edu.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/akademia-wsb.png" alt="Akademia WSB"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://wsfip.edu.pl/pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/wsfip.png" alt="WSFiP"/></a></figure>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container tg-sectionspace">
        <div className="row">
          <div
            className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8">
            <div className="tg-sectionhead">
              <div className="tg-sectionheading">
                <h2>Patronat medialny</h2>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <ul className="tg-brands">
              <li className="tg-brand">
                <figure><a href="https://redakcjabb.pl/" target="_blank" rel="noopener noreferrer"><img
                  src="images/partnerzy/redakcja_bb.png" alt="Redakcja BB"/></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://beskidzka24.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/media/beskid.png" alt="Beskidzka24" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="http://kronika.beskidzka.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/partnerzy/kronika-beskidzka.png" alt="Kronika Beskidzka" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://bielsko.biala.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/partnerzy/bielsko-biala.png" alt="Bielsko Biała" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://dotnetomaniak.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/media/dotnetomaniak.png" alt="Dotnetomaniak" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://mrdev.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/media/mrdev.png" alt="Mr Dev" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://webmastah.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/media/webmastah.png" alt="Webmastah" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure>
                  <img src="images/media/kurier.bb.png" alt="Kurier.BB" /></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://gamedevjs.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/media/game-dev.png" alt="GameDev" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="https://www.radiobielsko.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/media/radio-bielsko.png" alt="Radio Bielsko" /></a></figure>
              </li>
              <li className="tg-brand">
                <figure><a href="http://gazetabeskidzka.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="images/media/gazeta-beskidzka.png" alt="Gazeta beskidzka" /></a></figure>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </>
)

export default Sponsors
